import { FormControl, FormGroup } from '@angular/forms';
import {
  DeliveryManifest,
  DeliveryManifestReportResponse,
} from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`Delivery Manifest`,
  DATE: $localize`Date`,
  FROM: $localize`From`,
  ROUTE: $localize`Route`,
};

export const REPORT_FILE_NAME = 'Delivery-Manifest-Report';

export const PDF_REPORT = {
  NAME: 'Delivery Manifest',
  HEADER: {
    LOCATION: 'Location:',
    ROUTE: 'Route Id:',
    USER: 'User Id:',
  },
  NEEDED_INFO: {
    NAME: 'Name',
    SIGNATURE: 'Signature',
    TIME: 'Time',
  },
  FOOTER: {
    SUMMARY: 'Summary Data',
    LOCATION: 'Location:',
    ROUTE: 'Route Id:',
    USER: 'User Id:',
  },
  COLUMNS: [
    [
      'Stop'.toUpperCase(),
      'Customer'.toUpperCase(),
      'Street Address'.toUpperCase(),
      '',
      'City'.toUpperCase(),
      'Province'.toUpperCase(),
      'Postal Code'.toUpperCase(),
    ],
    [
      'Trackno'.toUpperCase(),
      '',
      'Shipper'.toUpperCase(),
      'Amt Due'.toUpperCase(),
      'Density'.toUpperCase(),
      'Completed'.toUpperCase(),
      'EDW',
    ],
    [
      'ScanCode'.toUpperCase(),
      'Dr Location'.toUpperCase(),
      'Info Notice'.toUpperCase(),
      'Amt Collected'.toUpperCase(),
      'Sig Clarify'.toUpperCase(),
      'Duplicate'.toUpperCase(),
      'Commit/Met'.toUpperCase(),
    ],
  ],
  DATA_FIELDS: [
    'routeId',
    'customer',
    'streetAddress',
    'city',
    'prov',
    'postal',
    'trackno',
    'shipper',
    'amtDue',
    'density',
    'completed',
    'edwStart/edwEnd',
    'scancode',
    'drLocation',
    'infoNotice',
    'amtCol',
    'sigClarify',
    'dup',
    'edwCommit/edwMet',
  ] as (keyof DeliveryManifest)[],
  DATA_ROWS: [
    [
      'routeId',
      'customer',
      'streetAddress',
      '*',
      'city',
      'prov',
      'postal',
    ] as (keyof DeliveryManifest)[],
    [
      'trackno',
      '*',
      'shipper',
      'amtDue',
      'density',
      'completed',
      'edwStart-edwEnd',
    ] as (keyof DeliveryManifest)[],
    [
      'scancode',
      'drLocation',
      'infoNotice',
      'amtCol',
      'sigClarify',
      'dup',
      'edwCommit/edwMet',
    ] as (keyof DeliveryManifest)[],
  ],
  SUMMARY: {
    HEADING: [
      'Delivery Stops NET',
      'Delivery Pkgs NET',
      'Missed Del Stop',
      'Missed Del Pkgs',
      'Send-Again COD',
      'Send-Again Paid',
      'Net COD',
      'Offload',
      'Open Stops',
      'Other',
      '% EDW Met',
    ],
    DATA_FIELDS: [
      'delStops',
      'delPkgs',
      'misDelStops',
      'misDelPkgs',
      'sendAgainCod',
      'sendAgainPaid',
      'netCod',
      'offLoad',
      'openStops',
      'otherPkgs',
      'percentageEdwMet',
    ] as (keyof DeliveryManifestReportResponse)[],
  },
};

export type DeliveryManifestGroup = {
  stop: number;
  routeId?: string;
  deliveryManifest: DeliveryManifest[];
  needsCompletion: boolean;
};

type DeliveryManifestFormField = {
  fromDate: FormControl<Date>;
  toDate: FormControl<Date>;
  route: FormControl<string>;
  reportFormat: FormControl<Options>;
};

export type DeliveryManifestFormGroup =
  FormGroup<DeliveryManifestFormField> | null;

export const DATA_ROWS: string[][] = [
  // 7 cells per row; tokens match your previous template logic
  [
    'routeId',
    'consignee',
    'address1/address2',
    'city',
    'state',
    'postalCode',
    'phone',
  ],
  [
    'poNumber',
    'shipmentId',
    'ref1-ref2',
    'pieces',
    'weight',
    'service',
    'notes',
  ],
  // Add more rows to mirror your HTML layout
];

export const SUMMARY = {
  HEADING: [
    'Delivery Stops NET',
    'Delivery Pkgs NET',
    'Missed Del Stop',
    'Missed Del Pkgs',
    'Send-Again COD',
    'Send-Again Paid',
    'Net COD',
    'Offload',
    'Open Stops',
    'Other',
    '% EDW Met',
  ],
  DATA_FIELDS: [
    'delStops', // Delivery Stops NET
    'delPkgs', // Delivery Pkgs NET
    'misDelStops', // Missed Del Stop
    'misDelPkgs', // Missed Del Pkgs
    'sendAgainCod', // Send-Again COD
    'sendAgainPaid', // Send-Again Paid
    'netCod', // Net COD
    'offLoad', // Offload
    'openStops', // Open Stops
    'otherPkgs', // Other
    'percentageEdwMet', // % EDW Met
  ],
};
